import React from "react"

export const MagnifyingGlassIcon = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={size * 24}
      height={size * 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="mag_glass"
        d="M9.937 16.125A6.194 6.194 0 0 1 3.75 9.938 6.194 6.194 0 0 1 9.937 3.75a6.194 6.194 0 0 1 6.188 6.188 6.194 6.194 0 0 1-6.188 6.187m7.208-.925a8.877 8.877 0 0 0 1.73-5.262C18.875 5.01 14.865 1 9.937 1 5.01 1 1 5.01 1 9.938c0 4.928 4.01 8.937 8.937 8.937a8.878 8.878 0 0 0 5.264-1.73L21.056 23 23 21.056 17.145 15.2"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}
